import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone', standalone: false })
export class PhonePipe implements PipeTransform {
  transform(value: string): string {
    if (value.startsWith('+')) {
      return value;
    }

    let result = '';

    result = value.replace(/\D/g, '');
    let resultWithoutCountry = result;
    let countryCode = '';
    if (result.length > 10) {
      const startIndex = result.length - 10;
      resultWithoutCountry = result.substr(startIndex, result.length);
      countryCode = result.substr(0, startIndex) + ' ';
    }

    let area = resultWithoutCountry.substr(0, 3);
    let region = resultWithoutCountry.substr(3, 3);
    let local = resultWithoutCountry.substr(6, 4);

    result = `${countryCode}(${area}) ${region}-${local}`;

    return result;
  }
}
